export enum CheckTypesEnum {
  'success' = 'success',
  'error' = 'error',
  'cancel' = 'cancel',
}
